import axios from 'axios';
import { API_URL } from '../config/index';

const instance = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
    devicetype: 'GOTablet',
  },
});

const getLangs = async (masterUser) => {
  const res = await instance.get(`/langs/${masterUser}`, { headers: { devicetype: 'GOTablet' } });
  return res;
};

const getLang = async (masterUser, language) => {
  const res = await instance.get(`/langs/${masterUser}/${language}`, { headers: { devicetype: 'GOTablet' } });
  return res;
};

const getDefaultLang = async (language) => {
  const res = await instance.get(`/defaultLangs/${language}`, { headers: { devicetype: 'GOTablet' } });
  return res;
};

const updateLang = async (masterUser, langName, language) => {
  const res = await instance.put(`/langs/${masterUser}/${langName}`, { language }, { headers: { devicetype: 'GOTablet' } });
  return res;
};

const newLang = async (masterUser, langName, language) => {
  const res = await instance.post(`/langs/${masterUser}/${langName}`, { language }, { headers: { devicetype: 'GOTablet' } });
  return res;
};
const deleteLang = async (masterUser, langName) => {
  const res = await instance.delete(`/langs/${masterUser}/${langName}`, { headers: { devicetype: 'GOTablet' } });
  return res;
};

export {
  getLangs,
  getLang,
  getDefaultLang,
  updateLang,
  newLang,
  deleteLang,
};
